<template>
  <div class="px-5">
    <div class="py-2 d-flex align-center justify-space-between">
      <p class="mb-0">{{ minText }}</p>
      <p class="mb-0">{{ maxText }}</p>
    </div>

    <v-range-slider
      v-model="priceRange"
      class="price-rage-slider my-5"
      color="orange50"
      thumb-color="white"
      track-color="gray40"
      :min="minPrice || 0"
      :max="maxPrice || 0"
      :step="stepSize"
    />
  </div>
</template>

<script>
let filterDebounce = null

export default {
  name: 'PriceRange',
  props: {
    value: { type: Array, default: () => [] },
    isClear: { type: Boolean, default: false },
    type: { type: String, default: '' },
    index: { type: Number, default: 0 },
    currency: { type: String, default: 'TWD' },
    filterKey: { type: String, default: '' },
    keyValue: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
  },
  emits: ['returnFilter', 'updateClearBtn'],
  data() {
    return {
      minPrice: 0,
      maxPrice: 0,
      priceRange: this.value,
    }
  },
  computed: {
    minValue() {
      const gap = this.gapValue(this.priceRange[0])
      return this.priceRange[0] - gap || this.priceRange[0]
    },
    currencyText() {
      let splitText = ''
      if (this.options.length > 0) {
        splitText = this.options[0].title.split(' ')[0]
      }
      return this.currency || splitText
    },
    maxValue() {
      const gap = this.gapValue(this.priceRange[1])
      return this.priceRange[1] - gap
    },
    minText() {
      return `${this.currencyText} ${this.minValue}`
    },
    maxText() {
      const isMaxPrice = this.maxPrice === this.maxValue
      return `${this.currencyText} ${this.maxValue}${isMaxPrice ? '+' : ''}`
    },
    stepSize() {
      return 10
    },
  },
  watch: {
    isClear(newVal) {
      if (newVal) {
        this.clearData()
        this.$emit('updateClearBtn', false)
      }
    },
    options(newOptions) {
      this.priceRange = [newOptions[0].value, newOptions[1].value]
    },
    priceRange(newRange, oldRange) {
      if (this.minValue !== oldRange[0] || this.maxValue !== oldRange[1]) {
        clearTimeout(filterDebounce)
        filterDebounce = setTimeout(() => {
          this.estimateTotalCount()
        }, 500)
      }
    },
  },
  created() {
    this.initPriceRange()
  },
  mounted() {},
  updated() {},
  methods: {
    initPriceRange() {
      const minPrice = parseFloat(this.options[0].value)
      const maxPrice = parseFloat(this.options[1].value)

      this.minPrice = minPrice
      this.maxPrice = maxPrice
    },
    gapValue(value) {
      return value % this.stepSize
    },
    clearData() {
      this.priceRange = [this.minPrice, this.maxPrice]
    },
    checkActivated() {
      const minPrice = this.priceRange[0]
      const maxPrice = this.priceRange[1]
      return minPrice !== this.minPrice || maxPrice !== this.maxPrice
    },
    estimateTotalCount() {
      const minValue = this.priceRange[0] === this.minPrice ? false : this.minValue
      const maxValue = this.priceRange[1] === this.maxPrice ? false : this.maxValue
      this.$emit('updateClearBtn', this.checkActivated())
      this.$emit('returnFilter', [minValue, maxValue])
    },
  },
}
</script>

<style lang="scss">
.price-rage-slider {
  .v-slider--horizontal {
    .v-slider__track-container {
      height: 4px;
    }
  }
  .v-slider__thumb {
    width: 20px;
    height: 20px;
    box-shadow: 0 4px 20px 0 rgba(37, 39, 41, 0.2);
  }
}
</style>
